import {DataFrameColumnType} from 'data-frames/DataFrameTypes';
import {BenchlingTypeDef} from 'data-types/benchling-type-def/BenchlingTypeDef';
import {List, Nullable} from 'data-types/benchling-type-def/ComplexTypes';

/**
 * Convert a serialized data frame column type to a `BenchlingTypeDef`
 *
 * This is useful for making data frame column types compatible with the core
 * front-end type def library (/client/data-types)
 *
 * @param columnType `DataFrameColumnType` to convert
 * @returns Corresponding `BenchlingTypeDef`
 */
export default function columnTypeToTypeDef(columnType: DataFrameColumnType): BenchlingTypeDef {
  let type: BenchlingTypeDef = columnType.leafType;

  if (columnType.isList) {
    type = new List(type);
  }

  if (columnType.isNullable) {
    type = new Nullable(type);
  }

  return type;
}
